<div class="aluno-selector-container">
  <label>Selecione o aluno:</label>
  <div class="alunos-list">
    <button 
      *ngFor="let aluno of alunos"
      class="aluno-card"
      [class.active]="alunoSelecionado?.id === aluno.id"
      [ngStyle]="getAlunoStyle(aluno)"
      (click)="selecionarAluno(aluno)">
      <div class="aluno-icon" [ngStyle]="getIconStyle(aluno)">
        <mat-icon>person</mat-icon>
      </div>
      <div class="aluno-info">
        <div class="aluno-nome">{{ aluno.nome }}</div>
        <div class="aluno-serie">{{ aluno.serie }}</div>
      </div>
    </button>
  </div>
</div>
